import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUrl';
import { formatTourDate } from '../../utils/text';

function TourCard({
  tourID,
  tourImage,
  tourTitle,
  tourPrice,
  tourDuration,
  tourLocation,
  tourRating,
  nextDate,
  availableSlots,
  totalSlots,
  hasPackages = false,
}) {
  const tourLink = tourID ? `/tour/${tourID}` : '/tour';
  const bookLink = tourID ? `/tour/${tourID}#book` : '/tour';
  const rating = tourRating || '4.8';
  const durationLabel = tourDuration ? `${tourDuration} Days` : null;

  return (
    <div className="tour-box th-ani">
      <div className="tour-box_img global-img">
        <img src={getImageUrl(tourImage, 'tour')} alt={tourTitle || 'Tour'} />
      </div>
      <div className="tour-content">
        <h3 className="box-title">
          <Link to={tourLink}>{tourTitle || 'Tour Package'}</Link>
        </h3>
        {tourLocation && (
          <p className="tour-location mb-2">
            <i className="fa-light fa-location-dot" /> {tourLocation}
          </p>
        )}
        {nextDate && (
          <p className="twa-tour-card-slots mb-2">
            <i className="fa-light fa-calendar" /> {formatTourDate(nextDate)}
            {availableSlots != null && totalSlots != null && (
              <span>
                {' · '}
                {availableSlots > 0 ? `${availableSlots} slots left` : 'Sold out'}
              </span>
            )}
          </p>
        )}
        <div className="tour-rating">
          <div className="star-rating" role="img" aria-label={`Rated ${rating} out of 5`}>
            <span style={{ width: '100%' }}>
              Rated <strong className="rating">{rating}</strong> out of 5
            </span>
          </div>
          <Link to={tourLink} className="woocommerce-review-link">
            <span className="count">{rating}</span> Rating
          </Link>
        </div>
        <h4 className="tour-box_price">
          <span className="currency">{tourPrice || '—'}</span>
          {hasPackages || (tourPrice && String(tourPrice).includes('–')) ? null : '/Person'}
        </h4>
        <div className="tour-action">
          <span>
            <i className="fa-light fa-clock" />
            {durationLabel || 'Flexible'}
          </span>
          <Link to={bookLink} className="th-btn style4">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TourCard;
